import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@20.17.30_db0@0.3.1_eslint@9.24.0_jiti@2.4.2__io_ocpep4f6fueeb25brfouasn6ne/node_modules/nuxt/dist/pages/runtime/validate.js";
import business_45report_45root_45redirect_45global from "/vercel/path0/middleware/businessReportRootRedirect.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@20.17.30_db0@0.3.1_eslint@9.24.0_jiti@2.4.2__io_ocpep4f6fueeb25brfouasn6ne/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  business_45report_45root_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}